import {timeout} from "../../vg/modules/timeout";
import axios from "axios";
import {eventHandler, listener} from "../../../../modules/vegas/js/util";

listener('input change', [
	'#modal-location .query',
	'#modal-city .query',
], (el, e) => {
	let modal = el.closest('.modal');
	const requestId = modal._locationLookupId = (modal._locationLookupId || 0) + 1;

	timeout(modal.id + '-location-lookup', 300, () => {
		let route = modal.dataset.routeLookup;
		let query = el.value;
		let containerResult = modal.querySelector('.addresses');
		let containerErrorEmpty = modal.querySelector('.error-empty');
		let addressPrefix = el.dataset.addressPrefix;

		if (addressPrefix && !query.startsWith(addressPrefix)) {
			delete el.dataset.addressPrefix;
			delete el.dataset.addressAfterLevel;
		}

		let params = {
			query: query,
			after_level: el.dataset.addressAfterLevel,
		};

		if (query) {
			axios.get(route, {params: params})
				.then(response => {
					if (requestId !== modal._locationLookupId) return;
					containerResult.innerHTML = '';
					let waitingForDetail = addressPrefix && query.trim() === addressPrefix;
					containerErrorEmpty.innerText = waitingForDetail
						? (parseInt(el.dataset.addressAfterLevel) === 7 ? 'Введите номер дома' : 'Начните вводить улицу')
						: 'Адрес не найден';

					if (response.data.addresses.length) {
						containerErrorEmpty.classList.add('d-none');

						response.data.addresses.forEach(function (addr) {
							let addressHtml = `
							<li><span data-addr data-level="${addr.level}">${addr.value}</span></li>
						`;

							containerResult.insertAdjacentHTML('beforeend', addressHtml);
						});
					} else {
						containerErrorEmpty.classList.remove('d-none');
					}
				}).catch(() => {
					if (requestId !== modal._locationLookupId) return;
					containerResult.replaceChildren();
					containerErrorEmpty.textContent = 'Не удалось найти адрес. Попробуйте ещё раз.';
					containerErrorEmpty.classList.remove('d-none');
				});
		} else {
			containerResult.innerHTML = '';
			containerErrorEmpty.classList.add('d-none');
		}
	});
});

listener('show.bs.modal', '#modal-location', (el, e) => {
	const title = el.querySelector('.modal-title');
	title.dataset.defaultTitle ||= title.textContent;
	const nearby = e.relatedTarget?.dataset.locationPurpose === 'nearby';
	title.textContent = nearby ? 'Укажите ваш адрес' : title.dataset.defaultTitle;
});

listener('shown.bs.modal', [
	'#modal-location',
], (el, e) => {
	setTimeout(() => {
		let input = el.querySelector('.query');
		input.focus();
		input.setSelectionRange(-1, -1);

		eventHandler.on(input, 'change');
	}, 50);
});

listener('click', [
	'#modal-location [data-addr]',
], (el, e) => {
	let modal = el.closest('.modal');
	let address = el.innerText;
	let level = parseInt(el.dataset.level);

	let input = el.closest('.modal').querySelector('.query')
	input.value = address + ' ';

	if ([6, 7, 65].includes(level)) {
		input.dataset.addressPrefix = address;
		input.dataset.addressAfterLevel = level;
	} else {
		delete input.dataset.addressPrefix;
		delete input.dataset.addressAfterLevel;
	}

	input.focus();
	input.setSelectionRange(1000, 1000);

	if (modal.id === 'modal-location') {
		eventHandler.on(input, 'change');
	}
}, true);

listener('click', [
	'#modal-city [data-addr]',
], (el, e) => {
	let modal = el.closest('.modal');
	let form = modal.querySelector('form');
	let address = el.innerText;
	let input = el.closest('.modal').querySelector('.query')
	input.value = address;

	form.requestSubmit();
}, true);

listener('show.bs.modal', '#modal-city', (el, e) => {
	axios.get('/location/get_nearest_cities').then((response) => {
		if (response.data.items.length) {
			let container = el.querySelector('.addresses');

			container.innerHTML = response.data.items.map(item => {
				return `<li><span data-addr>${item.title}</span></li>`;
			}).join('');
		}
	});
});
